"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProducerActiveTokenState = void 0;
var ProducerActiveTokenState;
(function (ProducerActiveTokenState) {
    ProducerActiveTokenState["TokenExpired"] = "TokenExpired";
    ProducerActiveTokenState["TokenAlreadyUsed"] = "TokenAlreadyUsed";
    ProducerActiveTokenState["TokenInvalid"] = "TokenInvalid";
    ProducerActiveTokenState["ActivatedNotVerified"] = "ActivatedNotVerified";
})(ProducerActiveTokenState = exports.ProducerActiveTokenState || (exports.ProducerActiveTokenState = {}));
//# sourceMappingURL=producer-active-token-state.js.map